import { create } from "zustand";
import { Profile } from "../Models/Profile";
import { addImageToArt, changeMainImage, createArt, deleteArt, getAllArt, getArt, removeArtImage, updateArt } from "../repositories/ArtRepository";
import { ArtDto } from "../Models/ArtDto";
import { Art } from "../Models/Art";

export interface ArtStore {
  fetchAllArt: () => Promise<Art[] | undefined>;
  fetchArt: (user: Profile, artId: number) => Promise<Art | undefined>;
  addArt: (
    user: Profile,
    art: ArtDto
  ) => Promise<number | undefined>;
  addArtImage: (user: Profile, artId: number, files: File[]) => Promise<number>;
  removeArtImage: (user: Profile, artId: number, fileId: number) => Promise<number>;
  changeMainImage: (user: Profile, artId: number, fileId: number) => Promise<number>;
  editArt: (
    user: Profile,
    art: Partial<ArtDto>,
    artId: number
  ) => Promise<number | undefined>;
  removeArt: (
    user: Profile,
    artId: number
  ) => Promise<number | undefined>;
}

export const useArt = create<ArtStore>(() => ({
  fetchAllArt: () => {
    return getAllArt();
  },
  fetchArt: (user, artId) => {
    return getArt(user, artId);
  },
  addArt: (user, art) => {
    return createArt(user, art);
  },
  addArtImage: (user, artId, files) => {
    return addImageToArt(user, artId, files)
  },
  removeArtImage: (user, artId, fileId) => {
    return removeArtImage(user, artId, fileId);
  },
  changeMainImage: (user, artId, fileId) => {
    return changeMainImage(user, artId, fileId);
  },
  editArt: (user, art, artId) => {
    return updateArt(user, art, artId);
  },
  removeArt: (user, artId) => {
    return deleteArt(user, artId);
  },
}));
